module.exports = __webpack_public_path__ + "img/chervon-black.cfa119bd.svg";